/**
 * Library script
 * Created 10.07.21
 *
 * @author Christoph Ehlers <ce@construktiv.de> | Construktiv GmbH
 */
import GlideSliderProvider from '../_shared/GlideSliderProvider';

new GlideSliderProvider('slider')
  .addListener('sliderActivated',(i)=>{
    /*
    const viewAreaRef = document.getElementById('content'); // use as referenz
    const padding = 20;
    const sliderSizeDesktop = (i.classList.contains('size-desktop--4')?4:1);
    const startLeft = sliderSizeDesktop === 1 ? 40 : (viewAreaRef.offsetWidth>window.innerWidth ? 0 : (window.innerWidth/2 - viewAreaRef.offsetWidth/2))+padding;
    const startRight = sliderSizeDesktop === 1 ? 40 :(viewAreaRef.offsetWidth>window.innerWidth ? window.innerWidth : startLeft+viewAreaRef.offsetWidth) - 60 - (padding*2);
    const controls = i.querySelectorAll('.control');
    if(controls.length){
      const oldContainer = controls[0].parentNode;

      controls.forEach(c=>{
        const newControlsContainer = i.getElementsByClassName('inner-wrapper')[0];

        newControlsContainer.appendChild(c);

        if(c.classList.contains('control--left')){
          c.setAttribute('style','left:'+startLeft+'px');
        }
        if(c.classList.contains('control--right')){
          c.setAttribute('style',(sliderSizeDesktop === 1 ? 'right:' :'left:')+startRight+'px');
        }
      });
      oldContainer.parentNode.removeChild(oldContainer); // remove .controls (old parent)
    }*/

  })
  .setEnableSliderMobile(true)
  .setEnableSliderDesktop(true)
  .init('.block-slider')
;